import { useEffect, useState } from "react";
import { fetchAddress } from "../../../lib/utils";

export default function LocationAddress({ latitude, longitude }) {
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!latitude || !longitude) return;

    let isMounted = true;

    setLoading(true);
    setError(false);

    fetchAddress(latitude, longitude)
      .then((res) => {
        if (isMounted) setAddress(res);
      })
      .catch(() => {
        if (isMounted) setError(true);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [latitude, longitude]);

  if (loading) {
    return (
      <div className="animate-pulse space-y-2">
        <div className="h-4 w-3/4 rounded bg-gray-300" />
        <div className="h-4 w-1/2 rounded bg-gray-300" />
      </div>
    );
  }

  if (error) {
    return <p className="text-red-500">Failed to load address</p>;
  }

  const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

  return (
    <a
      href={mapUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="text-sm text-gray-800 hover:text-blue-600 hover:underline transition-colors"
    >
      {address}
    </a>
  );
}
